export default __webpack_public_path__ + "img/ac220c7ab798e3c3e576295258dc3883.png";